import React from 'react'
import { IconGeneratorWrapper } from '../features/icon-generator'
import { Features, Instructions } from '../components/common'
import ApiPromotion from '../components/common/ApiPromotion'
import NudgeToApiPromotion from '../components/common/NudgeToApiPromotion'
import { Footer } from '../components/layout'

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <main className="py-8">
        <IconGeneratorWrapper />
        <NudgeToApiPromotion 
          gradient="linear-gradient(135deg, #F59E0B 0%, #F97316 40%, #EF4444 100%)"
          shadowColors={["rgba(245,158,11,0.35)", "rgba(239,68,68,0.35)"]}
        />
        <ApiPromotion />
        <Features />
        <Instructions />
      </main>

      <Footer />
    </div>
  )
}

export default Home 